// extracted by mini-css-extract-plugin
module.exports = {"main":"archive_main__WslYQ"};